<template>
  <div>
    <div class="container-fluid pagenotfound">
        <div class="row">
           <div class="col-md-12">
              <div class="content-pages">
               <h2>Whoops, our bad...</h2>
               <p class="font-medium">The page you requested was not found, and we have a fine guess why.</p>
               <ul>
                   <li>If you typed the URL directly, please make sure the spelling is correct.</li>
                   <li>If you clicked on a link to get here, the link is outdated.</li>
               </ul>
               <p class="font-medium">What can you do?</p>
               <p>Have no fear, help is near! There are many ways you can get back on track with Magento Store.</p>
               <ul>
                   <li>Go back to the previous page.</li>
                   <li>Use the search bar at the top of the page to search for your products.</li>
                   <li>Follow these links to get you back on track!</li>
               </ul>
               <p><router-link :to="{name:'Home'}">Home</router-link> | <router-link :to="{name:'dashboard'}">My Account</router-link></p>
              </div>
           </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'notFound',
  metaInfo: {
      title: 'Not Found',
      meta: [
        {
          name: 'description',
          content: 'Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.'
        },
        {
          property: 'keywords',
          content: 'Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online'
        }
      ]
    },
  data: function () {
        return {
           from_path:'',
           send_path:'',
        };
    },
    beforeRouteEnter(to, from, next) 
    {
        next((vm) => {
            vm.from_path = from.path;
        });
    },
    methods: {
      path: function(){
          if(this.from_path === '/'){
            this.send_path = this.$route.path;
          }
          else
          {
             this.send_path = this.from_path;
          }
          axios.get(this.$root.api_url+`/pim/pimresponse.php`, {
              params: {
              service:'404',
              store:this.$root.store,
              url_key:this.send_path
            }
          })
      }
    },
    created() {
            window.scrollTo(0, 0);
    },
    mounted() {
      setTimeout(() => {this.path();}, 0)
    }
}
</script>
